import React, { useTransition } from "react";
import ToothBox, { ToothData, ToothPart, ToothColor } from "./ToothBox";

import "./Tooth.scss";
import { useTranslation } from "react-i18next";
interface Props {
  teeth: ToothData[];
  currentColor: "felling" | "caries";
  onChange: (updatedTeeth: ToothData[]) => void;
}

const ToothChart: React.FC<Props> = ({ teeth, currentColor, onChange }) => {
  const { t } = useTranslation();
  const updateTooth = (id: number, parts: Record<ToothPart, ToothColor>) => {
    const updated = teeth.map((tooth) =>
      tooth.id === id ? { ...tooth, parts } : tooth
    );
    onChange(updated);
  };

  const toggleMissing = (id: number) => {
    const updated = teeth.map((tooth) =>
      tooth.id === id
        ? {
            ...tooth,
            missing: !tooth.missing,
            parts: {
              center: null,
              top: null,
              right: null,
              bottom: null,
              left: null,
            },
          }
        : tooth
    );
    onChange(updated);
  };

  // Pomoćne funkcije za sortiranje zuba po dentalnom rasporedu
  const upperLeft = teeth
    .filter((t) => t.id >= 1 && t.id <= 8)

    .map((t, index) => ({
      ...t,
      displayId: index + 1,
      groupNumber: 1,
    }))
    .reverse();

  const upperRight = teeth
    .filter((t) => t.id >= 9 && t.id <= 16)
    .map((t, index) => ({
      ...t,
      displayId: index + 1,
      groupNumber: 2,
    }));

  const lowerLeft = teeth
    .filter((t) => t.id >= 17 && t.id <= 24)
    .reverse()
    .map((t, index) => ({
      ...t,
      displayId: index + 1,
      groupNumber: 4,
    }))
    .reverse();

  const lowerRight = teeth
    .filter((t) => t.id >= 25 && t.id <= 32)
    .map((t, index) => ({
      ...t,
      displayId: index + 1,
      groupNumber: 3,
    }));

  return (
    <div>
      <h4>{t("Upper jaw")}</h4>
      <div style={{ display: "flex", gap: 4 }}>
        {[...upperLeft, ...upperRight].map((tooth: any) => (
          <div key={tooth.id} style={{ textAlign: "center" }}>
            <ToothBox
              toothId={tooth.id}
              data={tooth}
              currentColor={currentColor}
              onChange={updateTooth}
            />
            <button
              className="toggleToothVisibility"
              onClick={() => toggleMissing(tooth.id)}
            >
              {tooth.missing ? "o" : "x"}
            </button>
            <div className="toothNumber">
              {tooth.groupNumber}
              {tooth?.displayId ?? tooth.id}
            </div>
          </div>
        ))}
      </div>

      <h4>{t("Lower jaw")}</h4>
      <div style={{ display: "flex", gap: 4 }}>
        {[...lowerLeft, ...lowerRight].map((tooth) => (
          <div key={tooth.id} style={{ textAlign: "center" }}>
            <ToothBox
              toothId={tooth.id}
              data={tooth}
              currentColor={currentColor}
              onChange={updateTooth}
            />
            <button
              onClick={() => toggleMissing(tooth.id)}
              className="toggleToothVisibility"
            >
              {tooth.missing ? "o" : "x"}
            </button>
            <div className="toothNumber">
              {tooth.groupNumber}
              {tooth?.displayId ?? tooth.id}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ToothChart;
